import { render, staticRenderFns } from "./chateau-mouton-rothschild.vue?vue&type=template&id=1a998042&scoped=true"
import script from "./chateau-mouton-rothschild.vue?vue&type=script&lang=js"
export * from "./chateau-mouton-rothschild.vue?vue&type=script&lang=js"
import style0 from "./chateau-mouton-rothschild.vue?vue&type=style&index=0&id=1a998042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a998042",
  null
  
)

export default component.exports